module.exports = __webpack_public_path__ + "static/media/help.301e951b.mp3";